import type { Account } from '@syf-api-library/credit-accounts'

/**
 * Extracts display names from credit accounts API response
 * @param creditAccountsResponse - The credit accounts API response
 * @param accountId - Optional cipher account id to filter accounts
 * @returns Array of display names
 */
const getAccountDisplayName = (
  accounts?: Account[] | null,
  accountId?: string | null
): string[] => {
  const allAccounts = accounts ?? []

  if (accountId) {
    const account = allAccounts.find(
      (a) => a.info?.['cipher.accountId'] === accountId
    )
    return account?.product?.displayName ? [account.product.displayName] : []
  }

  const displayNames = allAccounts.flatMap(({ product }) =>
    product?.displayName ? [product.displayName] : []
  )
  return Array.from(new Set(displayNames))
}

export default getAccountDisplayName
